import $ from "jquery";
import Em from "./Em";

class Cbr extends Em {
    constructor() {
        super();
        this.init();
    }

    init() {
        this.selfDom();
        this.addCbrHelpers();
        this.events();
    }

    selfDom() {
        this.$inputs = $('input[type=checkbox], input[type=radio]');
        this.$helpers = this.$inputs.next('.cbr-helper');
    }

    events() {
        this.$helpers.off('click.Cbr');
        this.$helpers.on('click.Cbr', this.helperClickHandler.bind(this));
    }

    helperClickHandler(event) {
        const $helper = $(event.currentTarget);
        const $input = $helper.data('cbr-input');

        // if there is a parent label with the for attribute
        const inputId = $input.attr('id');
        const $parentLabel = $input.closest('label[for="' + inputId + '"]');
        if (inputId && $parentLabel.length > 0) {
            return;
        }

        if ($input) {
            if ($input.attr('type') === 'checkbox' || $input.attr('type') === 'radio') {
                if ($input.prop('checked')) {
                    $input.prop('checked', false).removeAttr('checked').trigger('change');
                } else {
                    $input.prop('checked', true).attr('checked', 'checked').trigger('change');
                }
            } else {
                this.$inputs.filter('[name="' + $input.attr('name') + '"]').prop('checked', false).removeAttr('checked');
                $input.prop('checked', true).attr('checked', 'checked').trigger('change');
            }

            return false;
        }
    }

    addCbrHelpers() {
        this.$inputs.each((i) => {
            const $input = this.$inputs.eq(i);
            let $helper = $input.next('.cbr-helper');

            if ( $helper.length < 1 ) {
                $helper = $('<span>', {class: 'cbr-helper'}).attr('style', $input.attr('style'));
            }

            if ($input.attr( 'type' ) === 'checkbox') {
                $helper.addClass('cb-helper');
            } else {
                $helper.addClass('rb-helper');
            }

            $input.data('cbr-helper', $helper);
            $helper.data('cbr-input', $input);

            $input.after($helper).hide();
        });

        this.$helpers = this.$inputs.next(this.$helpers);
    }
}

export default Cbr;